module.exports = __webpack_public_path__ + "assets/img/group-logo-a4712d49.png";